import clsx from 'clsx';
import { ReactElement, useState } from 'react';
import { LuInfo } from 'react-icons/lu';
import { HEADER_MESSAGE_CONTENT_QUERYResult } from 'sanity.types';

interface HeaderMessageProps {
    headerTopMessage: HEADER_MESSAGE_CONTENT_QUERYResult;
}

const HeaderMessage = ({
    headerTopMessage,
}: HeaderMessageProps): ReactElement | null => {
    const [messageHidden, setMessageHidden] = useState(false);
    const messageText = headerTopMessage?.[0]?.message;
    const messageType = headerTopMessage?.[0]?.headerMessageType;

    if (!messageText || messageHidden) {
        return null;
    }

    const containerClasses = clsx(
        'mx-auto',
        'min-h-8',
        'flex',
        'flex-row',
        'w-full',
        'justify-center',
        'items-center',
        'text-md',
        'p-2',
        'text-balance',
        'text-center',
        messageType === 'error' && 'bg-red-50',
        messageType === 'error' && 'text-red-800',
        messageType === 'warning' && 'bg-yellow-50',
        messageType === 'warning' && 'text-yellow-800',
        messageType === 'info' && 'bg-blue-200',
        messageType === 'info' && 'text-blue-800',
        'text-xs',
        'relative'
    );

    return (
        <div className={containerClasses}>
            <LuInfo size={32} className="mr-2" />
            {messageText}
            <button
                className="absolute right-4 top-[1px] text-lg"
                onClick={() => setMessageHidden(true)}
            >
                x
            </button>
        </div>
    );
};

export default HeaderMessage;
